(function() {
	'use strict';

	var GUID = 0;

	angular
		.module('components')
		.controller('ExpandableInformationComponentController', ExpandableInformationComponentController);

	/**
	 * An expandable component
	 * @param {jQueryElement} $element The component elemment
	 * @param {Service} AnalyticsDataLayerService AnalyticsDataLayerService
	 * @param {Service} Utilities Utilities
	 * @returns {self} Our new instance
	 * @ngInject
	 */
	function ExpandableInformationComponentController($element, AnalyticsDataLayerService, Utilities) {
		var vm = this;

		vm.$onInit = $onInit;
		vm.toggleOpen = toggleOpen;

		/**
		 * Initializes the component
		 * @returns {undefined}
		 */
		function $onInit() {
			$element.addClass('display-block');

			vm.open = false;
			vm.id = 'expandable-info-comp-' + GUID++;

			if (vm.defaultOpen) {
				vm.open = true;
			}

			if (vm.analyticsCategory && vm.analyticsLabel) {
				AnalyticsDataLayerService.triggerAnalyticsEvent(
					Utilities.generateEventData(vm.analyticsCategory, 'click', vm.analyticsLabel)
				);
			}
		}

		/**
		 * Toggles the open state.
		 * @returns {undefined}
		 */
		function toggleOpen() {
			var isFunction = angular.isFunction;

			vm.open = !vm.open;

			if (vm.open && isFunction(vm.onOpen)) {
				vm.onOpen();
			}

			if (!vm.open && isFunction(vm.onClose)) {
				vm.onClose();
			}
		}
	}
}());
